"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const framer_motion_1 = require("framer-motion");
const helpers_1 = require("../../lib/helpers");
const animations_1 = require("../../lib/config/animations");
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const ContentBg = (props) => {
    const { src, blurSrc } = props;
    const [sourceLoaded, setSourceLoaded] = react_1.useState(false);
    const [blurLoaded, setBlurLoaded] = react_1.useState(false);
    react_1.useEffect(() => {
        if (blurSrc) {
            const blurImg = new Image();
            blurImg.src = blurSrc;
            blurImg.addEventListener('load', () => setBlurLoaded(true));
        }
        else {
            setBlurLoaded(true);
        }
        const img = new Image();
        img.src = src;
        img.addEventListener('load', () => setSourceLoaded(true));
    }, [blurSrc, src]);
    let currentUrl = src;
    if (blurSrc) {
        currentUrl = sourceLoaded ? src : blurSrc;
    }
    return (react_1.default.createElement("div", Object.assign({}, helpers_1.usePrimitiveProps(helpers_1.without(props, ['src']))),
        react_1.default.createElement(framer_motion_1.AnimatePresence, null, blurLoaded && (react_1.default.createElement(framer_motion_1.motion.div, Object.assign({}, animations_1.getAnimationProps(animations_1.FadeInAnim), { style: { backgroundImage: `url(${currentUrl})` }, className: "j-content-bg-img" })))),
        react_1.default.createElement("div", { className: "j-content-bg-overlay" })));
};
exports.default = withJourney_1.default('j-content-bg', ContentBg);
